var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlackImportant(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons /  Webapp UI",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66681 3.66552C5.28728 2.04507 7.52772 1.04169 10.0013 1.04169C12.4749 1.04169 14.7153 2.04507 16.3358 3.66552L15.8938 4.10746L16.3358 3.66552C17.9562 5.286 18.9596 7.52643 18.9596 10C18.9596 12.4736 17.9562 14.714 16.3358 16.3345C14.7153 17.955 12.4749 18.9584 10.0013 18.9584C7.52772 18.9584 5.28728 17.955 3.6668 16.3345L4.10874 15.8926L3.6668 16.3345C2.04635 14.714 1.04297 12.4736 1.04297 10C1.04297 7.52644 2.04635 5.286 3.6668 3.66552L3.66681 3.66552ZM10.0013 2.29169C7.87255 2.29169 5.94632 3.15379 4.55068 4.54941C3.15506 5.94505 2.29297 7.87127 2.29297 10C2.29297 12.1288 3.15507 14.055 4.55069 15.4506C5.94633 16.8462 7.87256 17.7084 10.0013 17.7084C12.13 17.7084 14.0563 16.8462 15.4519 15.4506C16.8475 14.055 17.7096 12.1288 17.7096 10C17.7096 7.87127 16.8475 5.94504 15.4519 4.54941C14.0563 3.15379 12.1301 2.29169 10.0013 2.29169Z",
    fill: "#1C1B1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9987 4.58331C10.574 4.58331 11.0404 5.04969 11.0404 5.62498C11.0404 6.20027 10.574 6.66665 9.9987 6.66665C9.42341 6.66665 8.95703 6.20027 8.95703 5.62498C8.95703 5.04969 9.42341 4.58331 9.9987 4.58331Z",
    fill: "#1C1B1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 8.33331C8.75 7.98814 9.02982 7.70831 9.375 7.70831H10.2083C10.5535 7.70831 10.8333 7.98814 10.8333 8.33331V14.1666C10.8333 14.5118 10.5535 14.7916 10.2083 14.7916C9.86316 14.7916 9.58333 14.5118 9.58333 14.1666V8.95831H9.375C9.02982 8.95831 8.75 8.67849 8.75 8.33331Z",
    fill: "#1C1B1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.125 14.1667C8.125 13.8215 8.40482 13.5417 8.75 13.5417H11.6667C12.0118 13.5417 12.2917 13.8215 12.2917 14.1667C12.2917 14.5119 12.0118 14.7917 11.6667 14.7917H8.75C8.40482 14.7917 8.125 14.5119 8.125 14.1667Z",
    fill: "#1C1B1E"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackImportant);
export default __webpack_public_path__ + "static/media/black-important.083c8c00cce4fb27514c4caecd07363b.svg";
export { ForwardRef as ReactComponent };